import { Component, ElementRef, ViewChild } from '@angular/core';
import { TooltipPosition } from './tooltip-position';
import { TooltipTheme } from './tooltip-theme';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent {
  position: TooltipPosition = TooltipPosition.ABOVE;
  theme: TooltipTheme = TooltipTheme.LIGHT;
  tooltip = '';
  shortcut = '';
  left = 0;
  top = 0;
  visible = false;

  @ViewChild('tooltipBox', { static: true })
  private readonly tooltipBox!: ElementRef<HTMLElement>;

  constructor() {}

  showInTopLayer(): void {
    const element = this.tooltipBox.nativeElement;

    if (typeof element.showPopover !== 'function') {
      return;
    }

    element.setAttribute('popover', 'manual');
    element.showPopover();
  }
}
